import { API } from 'aws-amplify';
import { SPED_NOTES_URL_APPEND } from 'constants';

export const getAllSpedNotes = async (startDate, endDate, archived) => {
  const params = {
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
  };

  const spedNotes = await API.get(
    'delta-api',
    `${SPED_NOTES_URL_APPEND}${archived ? 'archived' : ''}`,
    {
      headers: {},
      queryStringParameters: params,
    }
  );

  return spedNotes;
};

export const getStudentSpedNote = async (noteId) => {
  const filterOptions = await API.get(
    'delta-api',
    `${SPED_NOTES_URL_APPEND}${noteId}`
  );
  return filterOptions;
};

export const getStudentSpedNotes = async (
  startDate,
  endDate,
  studentId,
  archived
) => {
  const params = {
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
  };

  const spedNotes = await API.get(
    'delta-api',
    `${SPED_NOTES_URL_APPEND}student/${studentId}${
      archived ? '/archived' : ''
    }`,
    {
      headers: {},
      queryStringParameters: params,
    }
  );

  return spedNotes;
};

export const getSpedNotesFilterOptions = async () => {
  const filterOptions = await API.get(
    'delta-api',
    `${SPED_NOTES_URL_APPEND}filterOptions`
  );
  return filterOptions;
};

export const postSpedNote = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${SPED_NOTES_URL_APPEND}`, myPayload);
};

export const putSpedNote = async (payload, noteId) => {
  const myPayload = {
    body: payload,
  };

  await API.put('delta-api', `${SPED_NOTES_URL_APPEND}${noteId}`, myPayload);
};

export const postSpedNoteBulk = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${SPED_NOTES_URL_APPEND}bulk`, myPayload);
};

export const postSpedNoteArchive = async (noteId) => {
  await API.post('delta-api', `${SPED_NOTES_URL_APPEND}${noteId}/archive`);
};

export const postSpedNoteUnArchive = async (noteId) => {
  await API.post('delta-api', `${SPED_NOTES_URL_APPEND}${noteId}/unarchive`);
};
